/**
 * Select input that retrieves remote data.
 *
 * Values: `url` - Should return an array of options with attributes `id` and `text`.
 *
 * Example: { data: {controller: "remote-select", "remote-select-url-value": outcomes_search_path} }
 *
 */
import TomSelectController from "./tom_select_controller";

export default class extends TomSelectController {
  static values = {
    url: String,
    noResultsLabel: String,
  };

  configuration(overrides = {}) {
    const plugins = this.element.attributes["multiple"]
      ? ["remove_button", "caret_position"]
      : ["caret_position"];

    const defaults = {
      plugins: plugins,
      closeAfterSelect: !this.element.attributes["multiple"],
      labelField: "text",
      valueField: "id",
      searchField: ["text"],
      sortField: [{ field: "$order" }, { field: "$score" }],
      load: (q, callback) => this.search(q, callback),
      // Results are already filtered server-side by the query. Skip TomSelect's
      // local re-filtering, which mis-scores labels containing regex-special
      // characters (e.g. "Jane Doe (Teacher)") and can hide valid results.
      score: () => () => 1,
    };
    if (this.noResultsLabelValue) {
      defaults.render = {
        no_results: () => {
          return (
            '<div class="no-results">' + this.noResultsLabelValue + "</div>"
          );
        },
      };
    }

    return super.configuration({ ...defaults, ...overrides });
  }

  connect() {
    if (!super.connect()) return;

    this.tomselect.on("item_add", function (value, item) {
      this.setTextboxValue("");
      if (this.settings.closeAfterSelect) {
        this.blur();
      }
    });
  }

  search(q, callback) {
    var url =
      this.urlValue +
      (this.urlValue.includes("?") ? "&" : "?") +
      new URLSearchParams({ query: q });
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        this.element.tomselect.clearOptions();

        callback(json);
      })
      .catch(() => {
        callback();
      });
  }
}
